import React from "react";
import { PageHero, CTABlock, SectionLabel } from "@/components/Sections";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ASSETS } from "@/lib/data";
import { Calendar, Building, Sparkles } from "lucide-react";

export default function Kontorsstadning() {
  return (
    <>
      <PageHero
        eyebrow="Företagstjänst"
        title="Kontorsstädning för välmående arbetsplatser"
        intro="Vi börjar gärna med en genomgång av era lokaler för att förstå behov, ytor och rutiner. Därefter tar vi fram ett städschema som passar er verksamhet."
        image={ASSETS.officeCleaning}
        imageAlt="Kontorsstädning – Rena Tjänster"
      >
        <Link to="/kontakt#offertformular" data-testid="kontor-hero-cta">
          <Button className="bg-[#1E3A6F] hover:bg-[#152a51] text-white rounded-full px-7 py-6 font-medium">
            Begär offert
          </Button>
        </Link>
      </PageHero>

      <section className="py-20 lg:py-28" data-testid="kontor-info">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionLabel className="mb-4">Så jobbar vi</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900 mb-6">
            Flexibelt upplägg – små som stora kontor
          </h2>
          <p className="text-slate-600 leading-relaxed mb-4 max-w-3xl">
            Rena Tjänster utför kontorsstädning för både små och stora kontorslandskap. Vi kan städa
            dagligen, flera dagar i veckan eller enligt överenskommelse – både under och efter kontorstid.
          </p>
          <p className="text-slate-600 leading-relaxed mb-12 max-w-3xl">
            Målet är att ni ska få en ren, trivsam och välkomnande arbetsmiljö varje dag.
          </p>

          <div className="grid md:grid-cols-3 gap-5">
            {[
              { icon: Building, title: "Anpassat efter lokal", text: "Stora kontorslandskap eller mindre kontor – samma kvalitet." },
              { icon: Calendar, title: "Flexibla tider", text: "Vi städar dagligen eller enligt schema, även efter kontorstid." },
              { icon: Sparkles, title: "Rena ytor", text: "Mer hållbara produkter och noggrant utfört arbete." },
            ].map((b, i) => (
              <div key={i} className="bg-white rounded-2xl p-7 border border-slate-100" data-testid={`kontor-block-${i}`}>
                <div className="w-11 h-11 rounded-xl bg-[#1E3A6F]/8 text-[#1E3A6F] inline-flex items-center justify-center mb-4">
                  <b.icon className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <h3 className="font-display text-lg font-semibold mb-1.5">{b.title}</h3>
                <p className="text-sm text-slate-600">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABlock
        title="Vill ni ha hjälp med kontorsstädning?"
        description="Vi kommer gärna ut på plats för en kostnadsfri genomgång och tar fram ett städschema som passar er verksamhet."
      />
    </>
  );
}
